<template>
  <v-data-table :headers="headers" :items="facilitators" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo facilitador
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="editedItem.name"
                      label="Name"
                      :hide-details="!errors.editedItem"
                      :error-messages="errors.editedItem"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hpp"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há facilitadores de Histórico da Moléstia Atual cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "ConfigHFList",
    props: {
      facilitators: Array,
      refreshList: Function,
    },
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        headers: [
          { text: "Texto", value: "name" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Novo facilitador" : "Editar facilitador";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.facilitators.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medication_history/delete_medication_history_frequency.gql"),
            variables: {
              medicationHistoryFrequencyId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/medication_history/save_medication_history_frequency.gql"),
          variables: {
            medicationHistoryFrequencyId: this.lodash.get(this.editedItem, "id", ""),
            name: this.editedItem.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.editedItem.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
